export default __webpack_public_path__ + "static/media/logotipoBebote.9382a49d.png";